module.exports = __webpack_public_path__ + "static/media/icon_user.2dd67655.svg";